{
  "account.delete-confirm": [
    {
      "type": 0,
      "value": "Delete Account"
    }
  ],
  "account.delete-confirmation-instruction": [
    {
      "type": 0,
      "value": "Please type DELETE MY ACCOUNT to confirm:"
    }
  ],
  "account.delete-confirmation-title": [
    {
      "type": 0,
      "value": "Are you absolutely sure?"
    }
  ],
  "account.delete-confirmation-warning": [
    {
      "type": 0,
      "value": "This action cannot be undone. This will permanently delete your account and remove all data from our servers."
    }
  ],
  "account.delete-warning": [
    {
      "type": 0,
      "value": "Tenha em mente que você não poderá recuperar nenhum mapa mental que tenha criado. Todas as suas informações serão excluídas e não poderão ser restauradas."
    }
  ],
  "account.delete-warning-collaborations": [
    {
      "type": 0,
      "value": "All shared mindmaps and collaborations"
    }
  ],
  "account.delete-warning-consequences": [
    {
      "type": 0,
      "value": "This will permanently delete:"
    }
  ],
  "account.delete-warning-data": [
    {
      "type": 0,
      "value": "All your personal data and account information"
    }
  ],
  "account.delete-warning-description": [
    {
      "type": 0,
      "value": "Once you delete your account, there is no going back. Please be certain."
    }
  ],
  "account.delete-warning-history": [
    {
      "type": 0,
      "value": "All account history and activity logs"
    }
  ],
  "account.delete-warning-mindmaps": [
    {
      "type": 0,
      "value": "All your mindmaps and their content"
    }
  ],
  "account.delete-warning-title": [
    {
      "type": 0,
      "value": "Delete Account"
    }
  ],
  "accountinfo.button": [
    {
      "type": 0,
      "value": "Aceitar"
    }
  ],
  "accountinfo.deleteaccount": [
    {
      "type": 0,
      "value": "Excluir conta"
    }
  ],
  "accountinfo.email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "accountinfo.firstname": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "accountinfo.lastname": [
    {
      "type": 0,
      "value": "Sobrenome"
    }
  ],
  "accountinfo.personal-details": [
    {
      "type": 0,
      "value": "Personal Details"
    }
  ],
  "accountinfo.title": [
    {
      "type": 0,
      "value": "Informações da conta"
    }
  ],
  "action.cancel-button": [
    {
      "type": 0,
      "value": "Cancelar"
    }
  ],
  "action.close-button": [
    {
      "type": 0,
      "value": "Fechar"
    }
  ],
  "action.delete": [
    {
      "type": 0,
      "value": "Excluir"
    }
  ],
  "action.delete-description": [
    {
      "type": 0,
      "value": "O mapa mental excluído não poderá ser recuperado. Deseja continuar?"
    }
  ],
  "action.delete-title": [
    {
      "type": 0,
      "value": "Excluir"
    }
  ],
  "action.duplicate": [
    {
      "type": 0,
      "value": "Duplicar"
    }
  ],
  "action.export": [
    {
      "type": 0,
      "value": "Exportar"
    }
  ],
  "action.history": [
    {
      "type": 0,
      "value": "Histórico"
    }
  ],
  "action.history-description": [
    {
      "type": 0,
      "value": "Lista de alterações introduzidas nos últimos 90 dias."
    }
  ],
  "action.history-title": [
    {
      "type": 0,
      "value": "Histórico de versões"
    }
  ],
  "action.import": [
    {
      "type": 0,
      "value": "Importar"
    }
  ],
  "action.info": [
    {
      "type": 0,
      "value": "Informações"
    }
  ],
  "action.label": [
    {
      "type": 0,
      "value": "Adicionar rótulo"
    }
  ],
  "action.new": [
    {
      "type": 0,
      "value": "Novo mapa"
    }
  ],
  "action.open": [
    {
      "type": 0,
      "value": "Abrir"
    }
  ],
  "action.print": [
    {
      "type": 0,
      "value": "Imprimir"
    }
  ],
  "action.publish": [
    {
      "type": 0,
      "value": "Publicar"
    }
  ],
  "action.rename": [
    {
      "type": 0,
      "value": "Renomear"
    }
  ],
  "action.rename-description-placeholder": [
    {
      "type": 0,
      "value": "Descrição"
    }
  ],
  "action.rename-name-placeholder": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "action.share": [
    {
      "type": 0,
      "value": "Compartilhar"
    }
  ],
  "activation.error.message": [
    {
      "type": 0,
      "value": "We couldn't activate your account. The activation link may be invalid or expired. Please contact support for assistance."
    }
  ],
  "activation.error.title": [
    {
      "type": 0,
      "value": "Activation Failed"
    }
  ],
  "activation.loading.desc": [
    {
      "type": 0,
      "value": "Please wait while we activate your account..."
    }
  ],
  "activation.loading.title": [
    {
      "type": 0,
      "value": "Activating Your Account"
    }
  ],
  "activation.success.message": [
    {
      "type": 0,
      "value": "Your account has been activated. You can now sign in and start creating mind maps."
    }
  ],
  "activation.success.title": [
    {
      "type": 0,
      "value": "Account Activated Successfully"
    }
  ],
  "admin.auth-type": [
    {
      "type": 0,
      "value": "Tipo de autenticação"
    }
  ],
  "admin.change-password": [
    {
      "type": 0,
      "value": "Change password"
    }
  ],
  "admin.change-password-button": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.change-password-description": [
    {
      "type": 0,
      "value": "Change password for user: "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "admin.change-password-title": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "admin.confirm-password": [
    {
      "type": 0,
      "value": "Confirm Password"
    }
  ],
  "admin.delete": [
    {
      "type": 0,
      "value": "Excluir"
    }
  ],
  "admin.delete-user": [
    {
      "type": 0,
      "value": "Excluir usuário"
    }
  ],
  "admin.edit": [
    {
      "type": 0,
      "value": "Editar"
    }
  ],
  "admin.edit-user": [
    {
      "type": 0,
      "value": "Editar usuário"
    }
  ],
  "admin.lock-status": [
    {
      "type": 0,
      "value": "Status de bloqueio"
    }
  ],
  "admin.locked": [
    {
      "type": 0,
      "value": "Bloqueado"
    }
  ],
  "admin.new-password": [
    {
      "type": 0,
      "value": "New Password"
    }
  ],
  "admin.password-error-facebook": [
    {
      "type": 0,
      "value": "This user is authenticated via Facebook. Password changes are not available for Facebook accounts. Please ask the user to manage their password through their Facebook account."
    }
  ],
  "admin.password-error-failed": [
    {
      "type": 0,
      "value": "Failed to change password"
    }
  ],
  "admin.password-error-google": [
    {
      "type": 0,
      "value": "This user is authenticated via Google. Password changes are not available for Google accounts. Please ask the user to manage their password through their Google account."
    }
  ],
  "admin.password-error-length": [
    {
      "type": 0,
      "value": "Password must be at least 6 characters"
    }
  ],
  "admin.password-error-mismatch": [
    {
      "type": 0,
      "value": "Passwords do not match"
    }
  ],
  "admin.public": [
    {
      "type": 0,
      "value": "Público"
    }
  ],
  "admin.public-access": [
    {
      "type": 0,
      "value": "Acesso público"
    }
  ],
  "admin.refresh": [
    {
      "type": 0,
      "value": "Atualizar"
    }
  ],
  "admin.status": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "admin.status-active": [
    {
      "type": 0,
      "value": "Ativo"
    }
  ],
  "admin.status-clean": [
    {
      "type": 0,
      "value": "Limpar"
    }
  ],
  "admin.status-suspended": [
    {
      "type": 0,
      "value": "Suspenso"
    }
  ],
  "admin.suspend-user": [
    {
      "type": 0,
      "value": "Suspender usuário"
    }
  ],
  "admin.suspension-reason": [
    {
      "type": 0,
      "value": "Motivo da suspensão"
    }
  ],
  "admin.suspension-status": [
    {
      "type": 0,
      "value": "Status de suspensão"
    }
  ],
  "admin.suspension.abuse": [
    {
      "type": 0,
      "value": "Abuso"
    }
  ],
  "admin.suspension.inactivity": [
    {
      "type": 0,
      "value": "Inatividade"
    }
  ],
  "admin.suspension.manual-review": [
    {
      "type": 0,
      "value": "Revisão manual"
    }
  ],
  "admin.suspension.other": [
    {
      "type": 0,
      "value": "Outro"
    }
  ],
  "admin.suspension.security-concern": [
    {
      "type": 0,
      "value": "Preocupação de segurança"
    }
  ],
  "admin.suspension.terms-violation": [
    {
      "type": 0,
      "value": "Violação de termos"
    }
  ],
  "admin.system.db.url": [
    {
      "type": 0,
      "value": "URL"
    }
  ],
  "admin.system.jvm": [
    {
      "type": 0,
      "value": "JVM"
    }
  ],
  "admin.system.memory": [
    {
      "type": 0,
      "value": "Memory"
    }
  ],
  "admin.system.refresh": [
    {
      "type": 0,
      "value": "Refresh"
    }
  ],
  "admin.system.title": [
    {
      "type": 0,
      "value": "System Information"
    }
  ],
  "admin.unsuspend-user": [
    {
      "type": 0,
      "value": "Reativar usuário"
    }
  ],
  "admin.view-xml": [
    {
      "type": 0,
      "value": "Ver XML"
    }
  ],
  "changepwd.confirm-password": [
    {
      "type": 0,
      "value": "Confirmar senha"
    }
  ],
  "changepwd.description": [
    {
      "type": 0,
      "value": "Por favor, forneça a nova senha para sua conta."
    }
  ],
  "changepwd.password": [
    {
      "type": 0,
      "value": "Senha"
    }
  ],
  "changepwd.password-match": [
    {
      "type": 0,
      "value": "As senhas não coincidem. Tente novamente."
    }
  ],
  "changepwd.title": [
    {
      "type": 0,
      "value": "Alterar senha"
    }
  ],
  "common.allow-email-notifications": [
    {
      "type": 0,
      "value": "Permitir notificações por e-mail"
    }
  ],
  "common.delete": [
    {
      "type": 0,
      "value": "Excluir"
    }
  ],
  "common.delete-tag": [
    {
      "type": 0,
      "value": "Excluir tag"
    }
  ],
  "common.email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "common.emails": [
    {
      "type": 0,
      "value": "E-mails"
    }
  ],
  "common.first-name": [
    {
      "type": 0,
      "value": "Primeiro Nome"
    }
  ],
  "common.last-name": [
    {
      "type": 0,
      "value": "Sobrenome"
    }
  ],
  "common.loading": [
    {
      "type": 0,
      "value": "Loading..."
    }
  ],
  "common.locale": [
    {
      "type": 0,
      "value": "Idioma"
    }
  ],
  "common.login-form": [
    {
      "type": 0,
      "value": "Formulário de login"
    }
  ],
  "common.maps-list": [
    {
      "type": 0,
      "value": "Lista de mapas"
    }
  ],
  "common.open-drawer": [
    {
      "type": 0,
      "value": "Abrir menu"
    }
  ],
  "common.others": [
    {
      "type": 0,
      "value": "Outros"
    }
  ],
  "common.refresh": [
    {
      "type": 0,
      "value": "Refresh"
    }
  ],
  "common.registration-form": [
    {
      "type": 0,
      "value": "Formulário de registro"
    }
  ],
  "common.retry": [
    {
      "type": 0,
      "value": "Retry"
    }
  ],
  "common.settings": [
    {
      "type": 0,
      "value": "Configurações"
    }
  ],
  "common.terms-notice": [
    {
      "type": 0,
      "value": "By continuing, you agree to our "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Terms of Service"
        }
      ],
      "type": 8,
      "value": "termsLink"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Privacy Policy"
        }
      ],
      "type": 8,
      "value": "privacyLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "common.wait": [
    {
      "type": 0,
      "value": "Aguarde..."
    }
  ],
  "create.button": [
    {
      "type": 0,
      "value": "Criar"
    }
  ],
  "create.description": [
    {
      "type": 0,
      "value": "Por favor, preencha o nome e descrição do novo mapa."
    }
  ],
  "create.title": [
    {
      "type": 0,
      "value": "Criar um novo mapa mental"
    }
  ],
  "deletem.title": [
    {
      "type": 0,
      "value": "Todos os mapas selecionados serão excluídos"
    }
  ],
  "dialog.loading": [
    {
      "type": 0,
      "value": "Carregando..."
    }
  ],
  "duplicate.copy-prefix": [
    {
      "type": 0,
      "value": "Cópia de "
    }
  ],
  "duplicate.title": [
    {
      "type": 0,
      "value": "Duplicar"
    }
  ],
  "error.contact-support": [
    {
      "type": 0,
      "value": "Precisa de ajuda? Entre em contato conosco em "
    },
    {
      "type": 1,
      "value": "support"
    }
  ],
  "error.generic-message": [
    {
      "type": 0,
      "value": "Tente novamente mais tarde ou contate o suporte se o problema continuar."
    }
  ],
  "error.generic-title": [
    {
      "type": 0,
      "value": "Encontramos um problema."
    }
  ],
  "error.go-back": [
    {
      "type": 0,
      "value": "Go Back"
    }
  ],
  "error.go-home": [
    {
      "type": 0,
      "value": "Go to Home"
    }
  ],
  "error.go-to-login": [
    {
      "type": 0,
      "value": "Sign In"
    }
  ],
  "error.map-title-required": [
    {
      "type": 0,
      "value": "O título do mapa é obrigatório e não pode estar vazio"
    }
  ],
  "error.map-unavailable-message": [
    {
      "type": 0,
      "value": "Este mapa mental não está disponível para exibição pública porque viola nossas políticas do site. Se precisar de mais ajuda, entre em contato com support@wisemapping.com."
    }
  ],
  "error.map-unavailable-title": [
    {
      "type": 0,
      "value": "Este mapa mental não está disponível para exibição pública."
    }
  ],
  "error.not-found-message": [
    {
      "type": 0,
      "value": "A página que você procura pode ter sido removida, renomeada ou estar temporariamente indisponível."
    }
  ],
  "error.not-found-title": [
    {
      "type": 0,
      "value": "Não encontramos essa página."
    }
  ],
  "error.page-title": [
    {
      "type": 0,
      "value": "Erro inesperado | WiseMapping"
    }
  ],
  "error.permission-denied-message": [
    {
      "type": 0,
      "value": "Se você acha que deveria ter acesso, entre em contato com o seu administrador."
    }
  ],
  "error.permission-denied-title": [
    {
      "type": 0,
      "value": "Você não tem acesso a esta página."
    }
  ],
  "expired.description": [
    {
      "type": 0,
      "value": "Sua sessão atual expirou. Faça login e tente novamente."
    }
  ],
  "expired.title": [
    {
      "type": 0,
      "value": "Sua sessão expirou"
    }
  ],
  "export.desc": [
    {
      "type": 0,
      "value": "Exporte este mapa no formato desejado e comece a usá-lo em suas apresentações ou compartilhando por e-mail"
    }
  ],
  "export.document": [
    {
      "type": 0,
      "value": "Ferramentas de mapa mental: exporte seu mapa mental em formatos de ferramentas de mapa mental de terceiros"
    }
  ],
  "export.document-label": [
    {
      "type": 0,
      "value": "Documento: exporte seu mapa mental em um documento independente pronto para compartilhar"
    }
  ],
  "export.image": [
    {
      "type": 0,
      "value": "Imagem: obtenha uma representação gráfica do seu mapa, incluindo todas as cores e formas."
    }
  ],
  "export.img-center": [
    {
      "type": 0,
      "value": "Centralizar e ajustar"
    }
  ],
  "export.title": [
    {
      "type": 0,
      "value": "Exportar"
    }
  ],
  "export.warning": [
    {
      "type": 0,
      "value": "A exportação para imagem (SVG, PNG, JPEG, PDF) está disponível apenas na barra de ferramentas do editor."
    }
  ],
  "footer.aboutus": [
    {
      "type": 0,
      "value": "Sobre nós"
    }
  ],
  "footer.col-community": [
    {
      "type": 0,
      "value": "Comunidade"
    }
  ],
  "footer.col-company": [
    {
      "type": 0,
      "value": "Empresa"
    }
  ],
  "footer.col-support": [
    {
      "type": 0,
      "value": "Suporte"
    }
  ],
  "footer.contactus": [
    {
      "type": 0,
      "value": "Entre em contato"
    }
  ],
  "footer.copyright": [
    {
      "type": 0,
      "value": "© "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " WiseMapping LLC"
    }
  ],
  "footer.donations": [
    {
      "type": 0,
      "value": "Doações"
    }
  ],
  "footer.faq": [
    {
      "type": 0,
      "value": "Perguntas frequentes"
    }
  ],
  "footer.feedback": [
    {
      "type": 0,
      "value": "Feedback"
    }
  ],
  "footer.news": [
    {
      "type": 0,
      "value": "Notícias"
    }
  ],
  "footer.opensource": [
    {
      "type": 0,
      "value": "Código aberto"
    }
  ],
  "footer.privacypolicy": [
    {
      "type": 0,
      "value": "Política de Privacidade"
    }
  ],
  "footer.termsandconditions": [
    {
      "type": 0,
      "value": "Termos e condições"
    }
  ],
  "footer.twitter": [
    {
      "type": 0,
      "value": "X"
    }
  ],
  "forgot.desc": [
    {
      "type": 0,
      "value": "Enviaremos um e-mail para redefinir sua senha."
    }
  ],
  "forgot.email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "forgot.oauth.back": [
    {
      "type": 0,
      "value": "Voltar ao login"
    }
  ],
  "forgot.oauth.message": [
    {
      "type": 0,
      "value": "Você não precisa de senha, faça login usando Facebook ou Google"
    }
  ],
  "forgot.page-title": [
    {
      "type": 0,
      "value": "Esqueci minha senha | WiseMapping"
    }
  ],
  "forgot.register": [
    {
      "type": 0,
      "value": "Enviar link de recuperação"
    }
  ],
  "forgot.success.desc": [
    {
      "type": 0,
      "value": "Enviamos um e-mail que permitirá redefinir sua senha. Você deve recebê-lo nos próximos minutos."
    }
  ],
  "forgot.success.title": [
    {
      "type": 0,
      "value": "Sua senha temporária foi enviada."
    }
  ],
  "forgot.title": [
    {
      "type": 0,
      "value": "Redefinir sua senha"
    }
  ],
  "forgotsuccess.page-title": [
    {
      "type": 0,
      "value": "Senha recuperada | WiseMapping"
    }
  ],
  "header.donthaveaccount": [
    {
      "type": 0,
      "value": "Não tem uma conta?"
    }
  ],
  "header.haveaccount": [
    {
      "type": 0,
      "value": "Já tem uma conta?"
    }
  ],
  "help.support": [
    {
      "type": 0,
      "value": "Suporte"
    }
  ],
  "history.no-changes": [
    {
      "type": 0,
      "value": "Não há alterações disponíveis"
    }
  ],
  "import.button": [
    {
      "type": 0,
      "value": "Criar"
    }
  ],
  "import.description": [
    {
      "type": 0,
      "value": "Você pode importar mapas do WiseMapping, FreeMind, Freeplane, XMind, MindManager e OPML para sua lista de mapas. Selecione o arquivo que deseja importar."
    }
  ],
  "import.error-file": [
    {
      "type": 0,
      "value": "Erro de importação "
    },
    {
      "type": 1,
      "value": "error"
    }
  ],
  "import.title": [
    {
      "type": 0,
      "value": "Importar mapa mental existente"
    }
  ],
  "info.basic-info": [
    {
      "type": 0,
      "value": "Informações básicas"
    }
  ],
  "info.button": [
    {
      "type": 0,
      "value": "Aceitar"
    }
  ],
  "info.creation-time": [
    {
      "type": 0,
      "value": "Data de criação"
    }
  ],
  "info.creator": [
    {
      "type": 0,
      "value": "Criador"
    }
  ],
  "info.description": [
    {
      "type": 0,
      "value": "Descrição"
    }
  ],
  "info.description-msg": [
    {
      "type": 0,
      "value": "Ao publicar o mapa, você o torna visível para todos na Internet."
    }
  ],
  "info.modified-time": [
    {
      "type": 0,
      "value": "Data da última modificação"
    }
  ],
  "info.modified-tny": [
    {
      "type": 0,
      "value": "Última modificação por"
    }
  ],
  "info.name": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "info.public-visibility": [
    {
      "type": 0,
      "value": "Visível publicamente"
    }
  ],
  "info.sharing": [
    {
      "type": 0,
      "value": "Compartilhamento"
    }
  ],
  "info.starred": [
    {
      "type": 0,
      "value": "Favoritos"
    }
  ],
  "info.title": [
    {
      "type": 0,
      "value": "Informações"
    }
  ],
  "label.add-button": [
    {
      "type": 0,
      "value": "Adicionar rótulo"
    }
  ],
  "label.add-for": [
    {
      "type": 0,
      "value": "Editando rótulos para o mapa:"
    }
  ],
  "label.add-placeholder": [
    {
      "type": 0,
      "value": "Título do rótulo"
    }
  ],
  "label.change-color": [
    {
      "type": 0,
      "value": "Alterar cor do rótulo"
    }
  ],
  "label.delete-description": [
    {
      "type": 0,
      "value": "será excluído, incluindo suas associações com todos os mapas existentes. Deseja continuar?"
    }
  ],
  "label.delete-title": [
    {
      "type": 0,
      "value": "Confirmar exclusão do rótulo"
    }
  ],
  "label.description": [
    {
      "type": 0,
      "value": "Use rótulos para organizar seus mapas."
    }
  ],
  "label.maps-count": [
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " mapas"
    }
  ],
  "label.title": [
    {
      "type": 0,
      "value": "Adicionar um rótulo"
    }
  ],
  "language.change": [
    {
      "type": 0,
      "value": "Alterar idioma"
    }
  ],
  "language.help": [
    {
      "type": 0,
      "value": "Ajudar a traduzir"
    }
  ],
  "login.desc": [
    {
      "type": 0,
      "value": "Faça login em sua conta"
    }
  ],
  "login.division": [
    {
      "type": 0,
      "value": "ou"
    }
  ],
  "login.email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "login.error": [
    {
      "type": 0,
      "value": "O endereço de e-mail ou senha inseridos não são válidos."
    }
  ],
  "login.facebook.button": [
    {
      "type": 0,
      "value": "Entrar com Facebook"
    }
  ],
  "login.forgotpwd": [
    {
      "type": 0,
      "value": "Esqueci minha senha?"
    }
  ],
  "login.generic-error": [
    {
      "type": 0,
      "value": "An error occurred during authentication. Please try again."
    }
  ],
  "login.google.button": [
    {
      "type": 0,
      "value": "Entrar com Google"
    }
  ],
  "login.oauth-error": [
    {
      "type": 0,
      "value": "OAuth authentication failed. Please try again or use a different sign-in method."
    }
  ],
  "login.page-title": [
    {
      "type": 0,
      "value": "Login | WiseMapping"
    }
  ],
  "login.password": [
    {
      "type": 0,
      "value": "Senha"
    }
  ],
  "login.redirecting": [
    {
      "type": 0,
      "value": "Redirecionando..."
    }
  ],
  "login.server-error": [
    {
      "type": 0,
      "value": "An unexpected error occurred. Please try again later."
    }
  ],
  "login.shared-map-notice": [
    {
      "type": 0,
      "value": "Um mapa mental foi compartilhado com você. Por favor, faça login para acessá-lo. Não tem uma conta? Registre-se gratuitamente ou use sua conta do Google/Facebook."
    }
  ],
  "login.signin": [
    {
      "type": 0,
      "value": "Entrar"
    }
  ],
  "login.signup": [
    {
      "type": 0,
      "value": "Cadastrar"
    }
  ],
  "login.title": [
    {
      "type": 0,
      "value": "Bem-vindo"
    }
  ],
  "map.creator": [
    {
      "type": 0,
      "value": "Criador"
    }
  ],
  "map.delete-selected": [
    {
      "type": 0,
      "value": "Excluir selecionado"
    }
  ],
  "map.last-update": [
    {
      "type": 0,
      "value": "Última atualização"
    }
  ],
  "map.more-actions": [
    {
      "type": 0,
      "value": "Mais ações"
    }
  ],
  "map.name": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "map.tooltip-add": [
    {
      "type": 0,
      "value": "Adicionar rótulo ao selecionado"
    }
  ],
  "maps.auth-required-default-message": [
    {
      "type": 0,
      "value": "You need to sign in to view your maps."
    }
  ],
  "maps.auth-required-heading": [
    {
      "type": 0,
      "value": "Sign in to access your maps"
    }
  ],
  "maps.auth-required-login": [
    {
      "type": 0,
      "value": "Go to login"
    }
  ],
  "maps.auth-required-title": [
    {
      "type": 0,
      "value": "Sign In Required | WiseMapping"
    }
  ],
  "maps.choose-file": [
    {
      "type": 0,
      "value": "Escolher um arquivo"
    }
  ],
  "maps.copilot-button": [
    {
      "type": 0,
      "value": "Copiloto IA"
    }
  ],
  "maps.copilot-dialog.continue": [
    {
      "type": 0,
      "value": "Abrir Copiloto"
    }
  ],
  "maps.copilot-dialog.description": [
    {
      "type": 0,
      "value": "Mind Map Copilot é um assistente de brainstorming alimentado pelo ChatGPT que transforma seus prompts em mapas mentais estruturados. Vamos abri-lo em uma nova aba para que você possa ampliar ideias, gerar tópicos e trazer o melhor de volta para o WiseMapping."
    }
  ],
  "maps.copilot-dialog.title": [
    {
      "type": 0,
      "value": "Copiloto de Mindmap com tecnologia ChatGPT"
    }
  ],
  "maps.copilot-tooltip": [
    {
      "type": 0,
      "value": "Inicie um mapa mental com o Copiloto IA"
    }
  ],
  "maps.create-tooltip": [
    {
      "type": 0,
      "value": "Criar um novo mapa mental"
    }
  ],
  "maps.empty-result": [
    {
      "type": 0,
      "value": "Nenhum mapa mental correspondente encontrado com os critérios de filtro atuais."
    }
  ],
  "maps.import-desc": [
    {
      "type": 0,
      "value": "Importar de outras ferramentas"
    }
  ],
  "maps.modified": [
    {
      "type": 0,
      "value": "Modificado"
    }
  ],
  "maps.modified-by": [
    {
      "type": 0,
      "value": "Modificado por"
    }
  ],
  "maps.modified-by-desc": [
    {
      "type": 0,
      "value": "Modificado por "
    },
    {
      "type": 1,
      "value": "by"
    },
    {
      "type": 0,
      "value": " em "
    },
    {
      "type": 1,
      "value": "on"
    }
  ],
  "maps.nav-all": [
    {
      "type": 0,
      "value": "Todos"
    }
  ],
  "maps.nav-onwned": [
    {
      "type": 0,
      "value": "Próprios"
    }
  ],
  "maps.nav-public": [
    {
      "type": 0,
      "value": "Públicos"
    }
  ],
  "maps.nav-shared": [
    {
      "type": 0,
      "value": "Compartilhados comigo"
    }
  ],
  "maps.nav-starred": [
    {
      "type": 0,
      "value": "Favoritos"
    }
  ],
  "maps.page-title": [
    {
      "type": 0,
      "value": "Meus mapas | WiseMapping"
    }
  ],
  "maps.revert": [
    {
      "type": 0,
      "value": "Reverter"
    }
  ],
  "maps.search-action": [
    {
      "type": 0,
      "value": "Pesquisar..."
    }
  ],
  "maps.tooltip-open": [
    {
      "type": 0,
      "value": "Abrir para edição"
    }
  ],
  "maps.tooltip-starred": [
    {
      "type": 0,
      "value": "Favoritos"
    }
  ],
  "maps.view": [
    {
      "type": 0,
      "value": "Visualizar"
    }
  ],
  "menu.account": [
    {
      "type": 0,
      "value": "Conta"
    }
  ],
  "menu.admin-console": [
    {
      "type": 0,
      "value": "Admin Console"
    }
  ],
  "menu.change-password": [
    {
      "type": 0,
      "value": "Alterar senha"
    }
  ],
  "menu.signout": [
    {
      "type": 0,
      "value": "Sair"
    }
  ],
  "publish.checkbox": [
    {
      "type": 0,
      "value": "Habilitar compartilhamento público"
    }
  ],
  "publish.copied": [
    {
      "type": 0,
      "value": "Copiado para a área de transferência!"
    }
  ],
  "publish.description": [
    {
      "type": 0,
      "value": "Ao publicar o mapa, você o torna visível para todos na Internet."
    }
  ],
  "publish.embedded": [
    {
      "type": 0,
      "value": "Incorporado"
    }
  ],
  "publish.embedded-msg": [
    {
      "type": 0,
      "value": "Clique no código para copiá-lo para a área de transferência:"
    }
  ],
  "publish.public-url": [
    {
      "type": 0,
      "value": "URL pública"
    }
  ],
  "publish.public-url-msg": [
    {
      "type": 0,
      "value": "Clique no link para copiá-lo para a área de transferência:"
    }
  ],
  "publish.title": [
    {
      "type": 0,
      "value": "Publicar"
    }
  ],
  "registation.success-title": [
    {
      "type": 0,
      "value": "Cadastro bem-sucedido | WiseMapping"
    }
  ],
  "registration.callback.back": [
    {
      "type": 0,
      "value": "Voltar ao login"
    }
  ],
  "registration.callback.confirm.description": [
    {
      "type": 0,
      "value": "Uma conta com o mesmo e-mail foi registrada anteriormente. Deseja vincular sua conta do "
    },
    {
      "type": 1,
      "value": "provider"
    },
    {
      "type": 0,
      "value": " a essa conta do WiseMapping?"
    }
  ],
  "registration.callback.confirm.title": [
    {
      "type": 0,
      "value": "Confirmar"
    }
  ],
  "registration.callback.sync": [
    {
      "type": 0,
      "value": "Sincronizar conta"
    }
  ],
  "registration.callback.waiting.description": [
    {
      "type": 0,
      "value": "Aguarde enquanto validamos sua identidade"
    }
  ],
  "registration.callback.waiting.title": [
    {
      "type": 0,
      "value": "Finalizando..."
    }
  ],
  "registration.desc": [
    {
      "type": 0,
      "value": "O cadastro é gratuito e leva apenas um momento"
    }
  ],
  "registration.division": [
    {
      "type": 0,
      "value": "ou"
    }
  ],
  "registration.email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "registration.error.title": [
    {
      "type": 0,
      "value": "Falha no Registro"
    }
  ],
  "registration.facebook.button": [
    {
      "type": 0,
      "value": "Registrar com Facebook"
    }
  ],
  "registration.firstname": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "registration.form-legend": [
    {
      "type": 0,
      "value": "Account Information"
    }
  ],
  "registration.google.button": [
    {
      "type": 0,
      "value": "Cadastrar com Google"
    }
  ],
  "registration.lastname": [
    {
      "type": 0,
      "value": "Sobrenome"
    }
  ],
  "registration.page-title": [
    {
      "type": 0,
      "value": "Cadastro | WiseMapping"
    }
  ],
  "registration.password": [
    {
      "type": 0,
      "value": "Senha"
    }
  ],
  "registration.recaptcha-notice": [
    {
      "type": 0,
      "value": "Este site é protegido pelo reCAPTCHA e aplicam-se a "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Política de Privacidade"
        }
      ],
      "type": 8,
      "value": "privacyLink"
    },
    {
      "type": 0,
      "value": " e os "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Termos de Serviço"
        }
      ],
      "type": 8,
      "value": "termsLink"
    },
    {
      "type": 0,
      "value": " do Google."
    }
  ],
  "registration.register": [
    {
      "type": 0,
      "value": "Cadastrar"
    }
  ],
  "registration.success.already-activated": [
    {
      "type": 0,
      "value": "Already activated your account?"
    }
  ],
  "registration.success.check-spam": [
    {
      "type": 0,
      "value": "If you don't see the email, please check your spam folder."
    }
  ],
  "registration.success.email-sent": [
    {
      "type": 0,
      "value": "We've sent an activation email to your inbox. Please check your email and click on the activation link to activate your account."
    }
  ],
  "registration.success.title": [
    {
      "type": 0,
      "value": "Registration Successful!"
    }
  ],
  "registration.title": [
    {
      "type": 0,
      "value": "Tornar-se membro"
    }
  ],
  "rename.description": [
    {
      "type": 0,
      "value": "Por favor, preencha o nome e descrição do novo mapa."
    }
  ],
  "rename.title": [
    {
      "type": 0,
      "value": "Renomear"
    }
  ],
  "reset-password.confirm-password": [
    {
      "type": 0,
      "value": "Confirm new password"
    }
  ],
  "reset-password.desc": [
    {
      "type": 0,
      "value": "Enter your new password below."
    }
  ],
  "reset-password.invalid-link": [
    {
      "type": 0,
      "value": "Invalid password reset link. Please request a new one."
    }
  ],
  "reset-password.mismatch": [
    {
      "type": 0,
      "value": "Passwords do not match."
    }
  ],
  "reset-password.page-title": [
    {
      "type": 0,
      "value": "Reset Password | WiseMapping"
    }
  ],
  "reset-password.password": [
    {
      "type": 0,
      "value": "New password"
    }
  ],
  "reset-password.request-new": [
    {
      "type": 0,
      "value": "Request new link"
    }
  ],
  "reset-password.submit": [
    {
      "type": 0,
      "value": "Set new password"
    }
  ],
  "reset-password.title": [
    {
      "type": 0,
      "value": "Set a new password"
    }
  ],
  "reset-password.too-long": [
    {
      "type": 0,
      "value": "Password must be less than 40 characters."
    }
  ],
  "reset-password.too-short": [
    {
      "type": 0,
      "value": "Password must be at least 8 characters."
    }
  ],
  "role.editor": [
    {
      "type": 0,
      "value": "Editor"
    }
  ],
  "role.owner": [
    {
      "type": 0,
      "value": "Proprietário"
    }
  ],
  "role.viewer": [
    {
      "type": 0,
      "value": "Visualizador"
    }
  ],
  "share.add-button": [
    {
      "type": 0,
      "value": "Compartilhar"
    }
  ],
  "share.add-message": [
    {
      "type": 0,
      "value": "Adicionar mensagem"
    }
  ],
  "share.adding-button": [
    {
      "type": 0,
      "value": "Compartilhando..."
    }
  ],
  "share.can-edit": [
    {
      "type": 0,
      "value": "Pode editar"
    }
  ],
  "share.delete": [
    {
      "type": 0,
      "value": "Excluir colaborador"
    }
  ],
  "share.delete-description": [
    {
      "type": 0,
      "value": "Adicione colaboradores. Eles receberão acesso instantâneo por e-mail para editar juntos."
    }
  ],
  "share.delete-title": [
    {
      "type": 0,
      "value": "Compartilhar com pessoas"
    }
  ],
  "share.message": [
    {
      "type": 0,
      "value": "Mensagem"
    }
  ],
  "share.table.actions": [
    {
      "type": 0,
      "value": "Actions"
    }
  ],
  "share.table.collaborator": [
    {
      "type": 0,
      "value": "Collaborator"
    }
  ],
  "share.table.role": [
    {
      "type": 0,
      "value": "Role"
    }
  ],
  "theme.dark": [
    {
      "type": 0,
      "value": "Escuro"
    }
  ],
  "theme.light": [
    {
      "type": 0,
      "value": "Claro"
    }
  ],
  "theme.toggle": [
    {
      "type": 0,
      "value": "Alternar Tema"
    }
  ],
  "validation.title-required": [
    {
      "type": 0,
      "value": "Título é obrigatório"
    }
  ]
}
